import styled from 'styled-components';

import PopupMenu from './PopupMenu';
import { PopupMenuProps } from './types';
import { getNotificationsKey, useNotifications } from '~/requests/notifications/useNotifications';
import { Menu } from 'semantic-ui-react';
import { formatDistanceToNow } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { getNotificationCountKey, useNotificationCount } from '~/requests/notifications';
import { ProjectStatus } from '~/constants';
import './styles.css';
import { PopupMenuEmptyMessage } from './PopupMenuEmptyMessage';
import Button from '~/components/Button';

const NotificationPopupMenuContainer = styled.div`
  .ui.menu {
    border: 1px solid #ddd;
    background: #fff;
    .item {
      font-weight: normal;
      height: auto;
      padding: 4px 8px;
      > div {
        padding: var(--x-small);
        line-height: 1.4;
        + div {
          font-size: 0.75rem;
          margin-left: 0;
          padding-top: 0;
        }
      }
    }
  }
`;

export default function NotificationsPopupMenu({ trigger, onClose }: PopupMenuProps) {
  const queryClient = useQueryClient();

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useNotifications();

  const { data: notificationsCount } = useNotificationCount();

  const history = useHistory();

  const notifications = data?.pages?.map((page: any) => page.results).flat();

  useEffect(() => {
    if (notifications && notificationsCount > 0) {
      // Whenever the notifications menu is open, invalidate the notification count cache
      // so that the notification count updates in real time
      queryClient.invalidateQueries(getNotificationCountKey());
    }
  }, [notifications, notificationsCount]);

  useEffect(() => {
    if (notificationsCount > 0) {
      // If there is a notification count > 0, invalidate the notifications cache
      queryClient.invalidateQueries(getNotificationsKey());
    }
  }, [notificationsCount]);

  const handleClick = (notification: any) => {
    let url;
    if (notification.useNotificationResolver) {
      url = `/notification/${notification.id}`;
    } else if (notification.metadata?.link) {
      url = notification.metadata.link;
    } else if (notification.projectStatus === ProjectStatus.MARKET_QUOTE) {
      url = `/pricing-estimate/${notification.projectId}`;
    } else if (notification.projectId) {
      url = `/project/${notification.projectId}`;
    } else if (notification.portfolioId) {
      url = `/portfolio/${notification.portfolioId}`;
    }

    if (url) {
      history.push(url);
      onClose();
    }
  };

  return (

    // <div className="notification-popup-menu-container">
    //   <div className="popup-menu" id="notificationsPopupMenu">
    //     {isFetching && !isFetchingNextPage && <div className="loader">Loading...</div>}
    //     <div className="infinite-scroll">
    //       {notifications?.map((notification: any, i: number) => (
    //         <div key={notification.id} className="menu-item" onClick={() => handleClick(notification)} style={{ whiteSpace: 'normal', lineHeight: '1.5rem' }}>
    //           <div>{notification.message}</div>
    //           <div>{formatDistanceToNow(new Date(notification.createdAt), { addSuffix: true })}</div>
    //           {i < notifications.length - 1 && <hr className="divider" />}
    //         </div>
    //       ))}
    //       {!hasNextPage && <div className="end-message">No more notifications to show.</div>}
    //     </div>
    //   </div>
    // </div>

    <NotificationPopupMenuContainer>
      <PopupMenu trigger={trigger} onClose={onClose} isLoading={isFetching && !isFetchingNextPage}>
        {notifications?.map((notification: any, i: number) => (
          <Menu.Item
            key={notification.id}
            className='legacy-popup-menu-item'
            onClick={() => handleClick(notification)}
            style={{
              whiteSpace: 'normal'
            }}
          >
            <div>
              {notification.message}
            </div>
            <div>
              {formatDistanceToNow(new Date(notification.createdAt), { addSuffix: true })}
            </div>
          </Menu.Item>
        ))}
        {notifications && notifications.length > 0 && hasNextPage?
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '8px 0' }}>
            <Button
              secondary
              size='small'
              onClick={() => {
                fetchNextPage();
              }}
              loading={isFetchingNextPage}
            >
              Load more
            </Button> 
          </div> :
          <PopupMenuEmptyMessage 
            message='No more notifications to show' 
            styles={notifications && notifications.length > 0 ? { borderTop: '1px solid #ddd', paddingTop: '8px' } : {}} 
          />
        }
      </PopupMenu>
    </NotificationPopupMenuContainer>
  );
}